import { useState } from 'react';
import { Box, InputAdornment, TextField } from '@mui/material';
import { styled } from '@mui/material/styles';
import { IconButtonAnimate } from '../../../components/animate';
import useLocales from '../../../hooks/useLocales';
import Iconify from '../../../components/Iconify';
import getHelpUrl from '../../../utils/helpUrl';

// -------------------

const InputStyle = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    height: theme.spacing(5),
    '&.Mui-focused': {
      boxShadow: theme.customShadows.z8,
    },
  },
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${theme.palette.grey[500_32]} !important`,
  },
}));

// --------------------

function SearchInKb() {
  const { currentLang, translate } = useLocales();
  const [search, setSearch] = useState('');

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  // Opens the FarmUp help (/help) in the user's language, with the search filled in.
  const handleSearchKb = (e) => {
    e.preventDefault();
    const url = getHelpUrl(currentLang.value, search);
    window.open(url, '_blank', 'noopener');
    setSearch('');
  };

  return (
    <Box component="form" noValidate autoComplete="off">
      <InputStyle
        placeholder={translate('searchInHelp')}
        value={search}
        onChange={handleSearchChange}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButtonAnimate type="submit" onClick={handleSearchKb}>
                <Iconify icon="bi:search" width={16} height={16} />
              </IconButtonAnimate>
            </InputAdornment>
          ),
        }}
        sx={{ my: 5, '& .MuiOutlinedInput-root': { pr: 0.5 } }}
      />
    </Box>
  );
}

export default SearchInKb;
